/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Feature_ImportsInputs */



/**
* | output |
* | --- |
* | "History imports from before the bot" |
*
* @param {Pricing_Feature_ImportsInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const pricing_feature_imports = /** @type {((inputs?: Pricing_Feature_ImportsInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Feature_ImportsInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Импорт истории до прихода бота")
	return /** @type {LocalizedString} */ ("History imports from before the bot")
});